export default "__VITE_ASSET__BWOjVQeE__"